import React from "react";
import { useTranslation } from "react-i18next";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Colors } from "@/theme";

const BoldTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: Colors.TABLE_HEADER1,
    color: Colors.GRAY_DARK,
    fontSize: 12,
    borderBottomWidth: 0,
    fontWeight: "bold",
    padding: `0px 16px`,
  },
}));

const NormalTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: Colors.TABLE_HEADER1,
    color: Colors.GRAY_DARK,
    fontSize: 10,
    borderBottomWidth: 1,
    padding: `0px 16px`,
  },
}));

const TableHeaderComponent = ({ products }) => {
  const { t } = useTranslation();
  const productHeaderCells = [
    {
      id: "cost",
      label: t("dashboard_screen.cost"),
      minWidth: 70,
      align: "center",
    },
    {
      id: "sell",
      label: t("dashboard_screen.sell"),
      minWidth: 70,
      align: "center",
    },
    {
      id: "margin",
      label: t("dashboard_screen.margin"),
      minWidth: 50,
      align: "center",
    },
    {
      id: "vol",
      label: t("dashboard_screen.vol"),
      minWidth: 80,
      align: "center",
    },
    {
      id: "closing_volume",
      label: t("dashboard_screen.closing_volume"),
      minWidth: 80,
      align: "center",
    },
  ];

  return (
    <TableHead sx={{ position: "sticky", zIndex: 10 }}>
      <TableRow>
        <BoldTableCell align="left" colSpan={1}>
          {t("dashboard_screen.date")}
        </BoldTableCell>
        {products.map((product) => (
          <BoldTableCell key={product.id} align="center" colSpan={5}>
            {product.product_code}
          </BoldTableCell>
        ))}
      </TableRow>
      <TableRow>
        <NormalTableCell
          sx={{ minWidth: 120, top: 27 }}
          align={"left"}
        ></NormalTableCell>
        {products
          .reduce((total) => [...total, ...productHeaderCells], [])
          .map((cell, id) => (
            <NormalTableCell
              key={id}
              sx={{ minWidth: cell.minWidth, top: 27 }}
              align={cell.align}
            >
              {cell.label}
            </NormalTableCell>
          ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeaderComponent;
